import { classNames } from "../../style/common"
import { IconProps } from "./common"

export function RainbowIcon(props: IconProps) {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames(props.classNames?.svg)}>
            <path className={classNames("fill-contrast-tertiary", props.classNames?.path)} d="M23,17a1,1,0,0,1-2,0A9,9,0,0,0,3,17a1,1,0,0,1-2,0,11,11,0,0,1,22,0ZM12,10a7.008,7.008,0,0,0-7,7,1,1,0,0,0,2,0,5,5,0,0,1,10,0,1,1,0,0,0,2,0A7.009,7.009,0,0,0,12,10Zm0,4a3,3,0,0,0-3,3,1,1,0,0,0,2,0,1,1,0,0,1,2,0,1,1,0,0,0,2,0A3,3,0,0,0,12,14Z" />
        </svg>
    )
}